export const MainMenuTitles = {
  Dashboard: 'Dashboard',
  Vehicle: 'Fahrzeug',
  Fleet: 'Fuhrpark',
  DownloadsAndFaq: 'Support',
  APIDoc: 'API Doc',
  Orders: 'Bestellungen',
  Tasks: 'Aufgaben',
  Accounting: 'Buchhaltung',
  BookRentalCar: 'Mietwagen buchen',
  Requests: 'Leasingausschreibung',
  Settings: 'Einstellungen',
  BecomeCustomer: 'Kunde werden',
  Customers: 'Kunden',
  Order: 'Bestellung',
  LeasingContracts: 'Leasingverträge',
  Report: 'Report',
  MarketSquare: 'Marktplatz',
  MyRequests: 'Anfragen'
} as const;

export type MainMenuTitle = (typeof MainMenuTitles)[keyof typeof MainMenuTitles];

export const SubMainMenuTitles = {
  RepairStatus: 'Reparaturstatus',
  ReportDamage: 'Schaden melden',
  Driver: 'Fahrer',
  DriverLicenseCheck: 'Führerscheinkontrolle',
  Vehicles: 'Fahrzeuge',
  Damage: 'Schäden',
  FuelReport: 'Kraftstoff Report',
  FuelCards: 'Tankkarten',
  Assignments: 'Aufträge',
  PoolCarBookings: 'Pool-Car Buchungen',
  MyPoolCarBookings: 'Meine Pool-Car Buchungen',
  LeaseEnd: 'Leasingende',
  PackagesAndPrice: 'Pakete & Preise',
  Tasks: 'Aufgaben',
  ServiceProvider: 'Deine Fragen',
  VehicleCost: 'Fahrzeugkosten',
  MonthlyBills: 'Monatsrechnungen',
  WallBoxBilling: 'Wallbox Abrechnung',
  SubmitFuelReceipt: 'Tankquittung einreichen',
  IncomingInvoices: 'Eingangsbelege',
  Orders: 'Bestellungen',
  Configurations: 'Konfigurationen',
  EmployeeConfigurations: 'Mitarbeiterkonfigurationen',
  Enterprise: 'Enterprise',
  Finn: 'Finn',
  MyRequests: 'Meine Anfragen',
  VehicleRequests: 'Fahrzeuganfragen',
  LeasingRequests: 'Leasinganfragen',
  Companies: 'Unternehmen',
  Budget: 'Mobilitätsbudget',
  CarPolicy: 'Car-Policy',
  ReferenceVehicle: 'Referenzfahrzeuge',
  Documents: 'Vertragsdokumente',
  Contracts: 'Rahmenverträge',
  SetupAssistant: 'Einrichtungsassistent',
  Import: 'Import',
  UserSettings: 'Konto',
  DecisionSupport: 'Entscheidungshilfen',
  CustomersRecruitCustomers: 'Kunden werben Kunden',
  CreateOffer: 'Angebot erstellen',
  Customers: 'Kunden',
  InviteCustomers: 'Kunden einladen',
  LongTermRental: 'Langzeitmiete',
  DocumentManager: 'Dokumentenmanager',
  Invoices: 'Eingangsbelege',
  TopDeals: 'Top Deals',
  Approvals: 'Freigaben',
  Cockpit: 'Portfolio Cockpit',
  CreateDamage: 'Schaden anlegen',
  FleetSettings: 'Flotteneinstellungen',
  AccountingSettings: 'Buchhaltungseinstellungen',
  Suppliers: 'Lieferanten',
  Discounts: 'Rabatte',
  LeasingContracts: 'Leasingverträge',
  PersonalEmailTemplate: 'Personalisierte E-Mail-Vorlage',
  DownloadsAndFaq: 'FAQ & Dokumente',
  Fines: 'Bußgelder',
  Exports: 'Exports',
  CashAdvance: 'Barauslage',
  Contact: 'Kontakt',
  WALL_E_BUSINESS_PARTNER_PROMOTION: 'WALL-E',
  GREENHOUSE_GAS_EMISSION_QUOTA: 'THG-Quote',
  MassDataCalculation: 'Massendatenkalkulation',
  CockpitSetup: 'Setup',
  AdminCenter: 'Admin Center',
  ServiceProviderTask: 'Deine Fragen',
  WheelsAndTires: 'Räder und Reifen'
} as const;

export type SubMainMenuTitle = (typeof SubMainMenuTitles)[keyof typeof SubMainMenuTitles];
